import { Image } from '@graphcommerce/image'
import { ProductPageItemFragment } from '@graphcommerce/magento-product'
import { Trans } from '@lingui/react'
import { Tooltip } from '@mui/material'
import templatesIcon from '../../../assets/images/templates_icon.svg'
// eslint-disable-next-line @typescript-eslint/no-restricted-imports

export type PrintTemplatesProps = Pick<ProductPageItemFragment, 'amfiles'>

export function PrintTemplates(props: PrintTemplatesProps) {
  const { amfiles } = props

  return (
    <div className=''>
      <h3 className='Type-XXL-Medium mb-3 flex flex-row items-center justify-start gap-2'>
        <Image
          alt=''
          src={templatesIcon}
          height={16}
          width={14}
          unoptimized
          layout='fixed'
          sx={{
            height: 16,
            width: 14,
          }}
        />
        <Trans id='Templates' />
      </h3>
      <p className='mb-6 italic text-medium-dark-gray'>
        <Trans
          id='Templates are not required to submit orders. Feel free to use them if you find it helpful in
        submitting your artwork.'
        />
      </p>
      {amfiles && amfiles?.length > 0 && (
        <div className='flex flex-wrap gap-4'>
          {amfiles?.map((file) => (
            // <Tooltip title={file?.label}>
              <a href={file?.url || '#'} className='inline-block' target='_blank' rel='noreferrer'>
                <div
                  key={file?.file_id}
                  className='Type-Large-Regular  whitespace-nowrap rounded-[5px] border-[1px] border-dotted border-light-gray px-4 py-[10px] hover:bg-[#6133941A] hover:text-material-ui-blue'
                >
                  {file?.label}
                </div>
              </a>
            // </Tooltip>
          ))}
        </div>
      )}
    </div>
  )
}
